import { store } from "global";
import { AudioInputType } from "models/app/player";

export const isInputLiveRadioFromState = () => isInputLiveRadio(store.getState().player.input);
export const isInputLiveRadio = (input: AudioInputType) => input === AudioInputType.LiveRadio;

export const isInputPlayQueueFromState = () => isInputPlayQueue(store.getState().player.input);
export const isInputPlayQueue = (input: AudioInputType) => input === AudioInputType.PlayQueue;
